// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2cYwQ","disabled":"FileBtn_disabled__NX0kd","warn":"FileBtn_warn__1WLRJ","fade":"FileBtn_fade__-bB35"};